import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCustomersData, getSellersData } from "../../Redux/actions/chat";
import { setNewConversationID } from "../../Redux/reducers/conversationIdSlice";
import "./Chat.css";
import ConversationWrapper from "./ConversationWrapper";
import MessageSideBar from "./MessageSideBar";

export default function ChatSection({ onMessageReceived }) {
  const user = useSelector((state) => state.user.user);
  const { customers, sellers, customersUnreadCount, sellersUnreadCount } = useSelector(state => state.showChat)

  const [activeTab, setActiveTab] = useState("1");


  const dispatch = useDispatch()

  const fetchCustomerData = useCallback(async () => {
    if (user !== null) {
      await dispatch(getCustomersData())
    }
  }, [user, dispatch])

  const fetchSellerData = useCallback(async () => {
    if (user !== null) {
      await dispatch(getSellersData())
    }
  }, [user, dispatch])

  useEffect(() => {
    const fetchingData = async () => {
      fetchCustomerData()
      fetchSellerData()
    };
    fetchingData();
  }, [fetchCustomerData, fetchSellerData, user]);



  return (
    <div className="chat-container shadow" style={{ zIndex: 99999 }}>

      <MessageSideBar
        onSellerTabPressed={async () => {
          if (activeTab !== '1') {
            fetchSellerData()
            dispatch(setNewConversationID({ id: 0, convContext: null }));

          }
        }}
        onCustomerTabPressed={async () => {
          if (activeTab !== '2') {
            fetchCustomerData()
            dispatch(setNewConversationID({ id: 0, convContext: null }));
          }
        }}
        sellers={sellers}
        customers={customers}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        customersUnreadCount={customersUnreadCount}
        sellersUnreadCount={sellersUnreadCount}
      />
      <ConversationWrapper activeTab={activeTab} />
    </div>
  );
}
